import { optimizeCss } from '@wix/css-optimization'
import type { BeckyRequestPayload } from '@wix/thunderbolt-becky-root'
import type { MetricsReporter, Logger } from '@wix/thunderbolt-becky-types'
import { shouldSplitByPresets } from './cssModuleUtils'

export const tryOptimizeCss = async (
	css: string,
	payload: BeckyRequestPayload,
	logger: Logger,
	metricsReporter: MetricsReporter
) => {
	const shouldSkipOptimization = shouldSplitByPresets(payload)
	let optimizedCss = css

	if (!shouldSkipOptimization) {
		try {
			logger.info('Before CSS optimization', { cssSize: css.length })

			optimizedCss = await metricsReporter.runAsyncAndReport(async () => {
				return await optimizeCss(css, {
					variablize: false,
				})
			}, 'tb-css-optimization')

			logger.info('After CSS optimization', {
				cssSize: optimizedCss.length,
			})
		} catch (e) {
			logger.warn('Optimizing CSS failed', e)
		}
	}
	return optimizedCss
}
